//引入请求字典接口
import {getDictCodeApi} from "@/api/module/common-api.js"
//引入本地缓存数据
import localDictCodes from "@/assets/data/dict.js"

export default {
  getDictCodeApi,
  localDictCodes,
  treeSetting: {
    labelField: "areaName"
  },
  axiosSetting: {
    axios: "haha"
  },
  formatterDictVersion: (data) => {
    console.log("🚀 ~ file: dict-config.js:19 ~ data:", data)
    return data.version
  }
}
